export function validateUrl(message, className) {
    const pattern = new RegExp('(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})','ig'); // fragment locator
    return message.replace(/\\s/g, ' ').replace(/\\n/g, '<br>').replace(pattern, ` <a href="$1" target="_blank"><u class=${className}>$1</u></a>`);
}

export function dentistLastMessage(message) {
    return message.replace(/\\s/g, ' ').replace(/\\n/g, ' ');
}


// WEBPACK FOOTER //
// ./src/utils/validator.js